import React from "react";
import { useMutation, useQuery } from "@apollo/client";
import { showSignupForm, timeConverter, isDateMoreThanXDaysFromToday, DEADLINE_DAYS } from "../../utils/timeConverter";
import Nav from "../../components/Nav";
import DishPhotoCard from "../dish/components/DishPhotoCard";
import AllergenIcon from "../../components/AllergenIcon";
import { GET_FOR_ALL_MENUS, GET_FOR_ALL_USER_SIGNUPS } from "../signups/gql/queries";
import { CREATE_SIGNUP, DELETE_SIGNUP } from "../signups/gql/mutations";
import { GET_ME } from "../user/gql/queries";
import "./ForAll.css";

const ForAll = () => {
  const { data: forAllMenusData, refetch: refetchForAllMenus } = useQuery(GET_FOR_ALL_MENUS);
  const { data: forAllUserSignupsData, refetch: refetchForAllUserSignups } = useQuery(GET_FOR_ALL_USER_SIGNUPS);

  const [createSignup] = useMutation(CREATE_SIGNUP);
  const [deleteSignup] = useMutation(DELETE_SIGNUP);
  const { data } = useQuery(GET_ME);
  const me = data?.me;

  const forAllMenus = forAllMenusData?.forAllMenus || [];
  const forAllUserSignups = forAllUserSignupsData?.forAllUserSignups || [];

  const availableMenus = forAllMenus.filter(menu => {
    return !forAllUserSignups.some(signup => 
      signup.menuItem._id === menu._id
    );
  });

  const onSubmit = async (event) => {
    try {
      const { data } = await createSignup({
        variables: {
          menuItem: event.target.id,
          user: me.userId,
          size: event.target.value,
        },
      });
      
      refetchForAllMenus();
      refetchForAllUserSignups();
      showModal();
    } catch (err) {
      console.error(err);
    }
  };

  const onDeleteClick = async (event) => {
    try {
      const { data } = await deleteSignup({
        variables: {
          signupId: event.target.id,
        },
      });
      
      refetchForAllUserSignups();
      refetchForAllMenus();
    } catch (err) {
      console.error(err);
    }
  };

  const showModal = () => {
    const modal = document.querySelector('.modalParent')
    modal.style.visibility = 'visible'
  };

  const closeModal = () => {
    const modal = document.querySelector('.modalParent')
    modal.style.visibility = 'hidden'
  }

  return (
    <>
      <div className="navAndHeader">
        <Nav />
      </div>

      <div className="modalParent">
        <div className="modalSuccessful">
          <h3>Signup Successful!</h3>
          <button className='ok' onClick={closeModal}><p>Close</p></button>
        </div>
      </div>

      <div className="mainContainer">
        <h1>Menus</h1>
        <div className="signupsContainer" id="forAllMenusContainer">
          {availableMenus.length === 0 ? (
            <div className="forAll-grid-center">
              <p className="errMsg forAll-error-message">
                No open menus
              </p>
            </div>
          ) : (
            availableMenus.map((menu) => (
              <div key={menu._id} className="signup">
                <div className="signupsRow" key={menu._id}>
                  <div className="openSignupInfo">
                    <div className="dishNameWithAllergens">
                      <p>{menu.dish?.dishName}</p>
                      <AllergenIcon
                        allergens={menu.dish?.allergens}
                        calories={menu.dish?.calories}
                      />
                    </div>
                    <p>{timeConverter(menu.menuDate)}</p>
                  </div>
                  <div className="addButtonAndPhoto">
                    <div className="addButton">
                      <p id={menu._id} className="addSignupPlus" onClick={showSignupForm}>+</p>
                    </div>
                    <div className="dishPhotoContainer">
                      <DishPhotoCard image={menu.dish?.dishPhoto} radius={"15"} border={"3px_solid_rgb:6B802A"} height={"130"} width={"130"} />
                    </div>
                  </div>
                </div>
                <div id={"form" + menu._id} className="signupForm">
                  <button id={menu._id} onClick={onSubmit} value="Small" className="sizeButtons">Small</button>
                  {
                    <button id={menu._id} onClick={onSubmit} value="Large" className="sizeButtons">Large</button>
                  }
                </div>
              </div>
            ))
          )}
        </div>

        <h1>Signups</h1>

        <div className="signupsContainer">
          {(() => {
            const sortedSignups = [...forAllUserSignups]
              .sort((a, b) => a.menuItem?.menuDate - b.menuItem?.menuDate);
            return sortedSignups.length === 0 ? (
              <div className="forAll-grid-center">
                <p className="errMsg forAll-error-message">
                  No signups
                </p>
              </div>
            ) : (
              sortedSignups.map((signup) => (
                <div key={signup._id} className="userSignup">
                  <div className="signupsRow">
                    <div className="yourSignupInfo">
                      <p>{timeConverter(signup.menuItem.menuDate)}</p>
                      <div className="dishNameWithAllergens">
                        <p>{signup.menuItem?.dish?.dishName}</p>
                        <AllergenIcon
                          allergens={signup.menuItem?.dish?.allergens}
                          calories={signup.menuItem?.dish?.calories}
                        />
                      </div>
                      <p>{signup.size}</p>
                    </div>
                    <div className="buttonAndPhoto">
                      {isDateMoreThanXDaysFromToday(signup.menuItem.menuDate, DEADLINE_DAYS) && (
                        <div className="editButton">
                          <p id={signup.menuItem._id} onClick={showSignupForm} className="editButtonText">Edit</p>
                        </div>
                      )}
                      {!isDateMoreThanXDaysFromToday(signup.menuItem.menuDate, DEADLINE_DAYS) && (
                        <div className="editButton forAll-disabled-button">
                          <p id={signup.menuItem._id} className="editButtonText">Edit</p>
                        </div>
                      )}
                      {isDateMoreThanXDaysFromToday(signup.menuItem.menuDate, DEADLINE_DAYS) && (
                        <div className="cancelButton">
                          <p id={signup._id} onClick={onDeleteClick} className="cancelButtonText">Cancel</p>
                        </div>
                      )}
                      {!isDateMoreThanXDaysFromToday(signup.menuItem.menuDate, DEADLINE_DAYS) && (
                        <div className="cancelButton forAll-disabled-button">
                          <p id={signup._id} className="cancelButtonText">Cancel</p>
                        </div>
                      )}
                      <div className="dishPhotoContainer">
                        <DishPhotoCard image={signup.menuItem?.dish?.dishPhoto} radius={"15"} border={"3px_solid_rgb:6B802A"} height={"130"} width={"130"} />
                      </div>
                    </div>
                  </div>
                  <div id={"form" + signup.menuItem._id} className="signupForm">
                    <button id={signup.menuItem._id} onClick={onSubmit} value="Small" className="sizeButtons">Small</button>
                  <button id={signup.menuItem._id} onClick={onSubmit} value="Large" className="sizeButtons">Large</button>
                  </div>
                </div>
              ))
            );
          })()}
        </div>
      </div>
    </>
  );
};

export default ForAll;
